var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUrlicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.1 10.3333V10.2333H6H3.33333H3.23333V10.3333V13V13.1H3.33333H6H6.1V13V10.3333ZM8.08531 3.85451L8 3.71498L7.91469 3.85451L6.63469 5.94784L6.54164 6.10001H6.72H9.28H9.45836L9.36531 5.94784L8.08531 3.85451ZM7.23333 9.10001V14.2333H2.1V9.10001H7.23333ZM4.51164 7.23334L8 1.52512L11.4884 7.23334H4.51164ZM11.6667 8.76668C13.2781 8.76668 14.5667 10.0552 14.5667 11.6667C14.5667 13.2781 13.2781 14.5667 11.6667 14.5667C10.0552 14.5667 8.76667 13.2781 8.76667 11.6667C8.76667 10.0552 10.0552 8.76668 11.6667 8.76668ZM11.6667 9.90001C11.1981 9.90001 10.7488 10.0861 10.4174 10.4175C10.0861 10.7488 9.9 11.1981 9.9 11.6667C9.9 12.1352 10.0861 12.5846 10.4174 12.9159C10.7488 13.2472 11.1981 13.4333 11.6667 13.4333C12.1352 13.4333 12.5846 13.2472 12.9159 12.9159C13.2472 12.5846 13.4333 12.1352 13.4333 11.6667C13.4333 11.1981 13.2472 10.7488 12.9159 10.4175C12.5846 10.0861 12.1352 9.90001 11.6667 9.90001Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUrlicon);
export default __webpack_public_path__ + "static/media/urlicon.394e672405feabec2056b6a801c967e3.svg";
export { ForwardRef as ReactComponent };